module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-08.deea55d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-08.jpg
// module id = OWOE
// module chunks = 52